import { match } from '@/utils/pattern-match-util'
import type { BookkeepingPlatform } from '@/features/bookkeeping/platform-connections/bookkeeping-platform'

export function formatBookkeepingPlatform(
  bookkeepingPlatform: BookkeepingPlatform,
) {
  return match(bookkeepingPlatform, {
    Xero: 'Xero',
    QuickBooks: 'QuickBooks',
    Other: 'Other',
  })
}

export function getBookkeepingPlatformLoginUrl(
  bookkeepingPlatform: BookkeepingPlatform,
) {
  switch (bookkeepingPlatform) {
    case 'QuickBooks':
      return 'https://accounts.intuit.com/app/sign-in'
    case 'Xero':
      return 'https://login.xero.com/identity/user/login'
    default:
      return null
  }
}
